export enum FlocosProductionStatus {
  IN_PRODUCTION = 'in_production',
  READY_TO_REVIEW = 'ready_to_review',
  REVIEWED = 'reviewed',
  COMPLETE = 'complete',
}

export function getFlocosProductionLabel({
  status,
  shortName,
  helperText,
}: {
  status: FlocosProductionStatus;
  shortName?: boolean;
  helperText?: boolean;
}): string {
  if (shortName) {
    switch (status) {
      case FlocosProductionStatus.IN_PRODUCTION:
        return 'Em produção';
      case FlocosProductionStatus.READY_TO_REVIEW:
        return 'Para  revisão';
      case FlocosProductionStatus.REVIEWED:
        return 'Revisado';
      case FlocosProductionStatus.COMPLETE:
        return 'Entregue';
    }
  }

  if (helperText) {
    switch (status) {
      case FlocosProductionStatus.IN_PRODUCTION:
        return 'A produção de flocos ainda está em andamento. Ainda não está pronta para revisão';
      case FlocosProductionStatus.READY_TO_REVIEW:
        return 'O floco está pronto para revisão!';
      case FlocosProductionStatus.REVIEWED:
        return 'A produção já foi revisada e está pronta para ser entregue ao entreposto.';
      case FlocosProductionStatus.COMPLETE:
        return 'A produção já foi entregue ao entreposto!';
    }
  }

  switch (status) {
    case FlocosProductionStatus.IN_PRODUCTION:
      return 'Em produção';
    case FlocosProductionStatus.READY_TO_REVIEW:
      return 'Pronto para revisão';
    case FlocosProductionStatus.REVIEWED:
      return 'Revisado e não beneficiado';
    case FlocosProductionStatus.COMPLETE:
      return 'Produção entregue ao entreposto';
  }
}
